import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLDiv = () => {
  return (
    <div className="html-container">
      <h1>HTML – The &lt;div&gt; Element</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          The <code>&lt;div&gt;</code> element is a generic container in HTML used to group together other elements for styling or layout purposes. 
          It has no semantic meaning on its own but is widely used with CSS and JavaScript.
        </p>
      </section>

      {/* 2. Syntax */}
      <section id="syntax">
        <h2>2. Syntax</h2>
        <p>Basic syntax of a div element:</p>
        <pre>
          <code>{`<div>
  <!-- Content goes here -->
</div>`}</code>
        </pre>
      </section>

      {/* 3. Attributes */}
      <section id="attributes">
        <h2>3. Common Attributes</h2>
        <ul>
          <li><strong>id:</strong> Unique identifier for the div. <code>&lt;div id="header"&gt;</code></li>
          <li><strong>class:</strong> Assign one or more classes for CSS styling. <code>&lt;div class="container"&gt;</code></li>
          <li><strong>style:</strong> Inline CSS styles. <code>&lt;div style="background: #f0f0f0;"&gt;</code></li>
          <li><strong>title:</strong> Adds a tooltip text. <code>&lt;div title="Tooltip text"&gt;</code></li>
        </ul>
      </section>

      {/* 4. Examples */}
      <section id="examples">
        <h2>4. Examples</h2>

        {/* Simple div */}
        <h3>Simple div</h3>
        <pre>
          <code>{`<div>
  <p>This is a simple div containing a paragraph.</p>
</div>`}</code>
        </pre>

        {/* Styled div */}
        <h3>Styled div</h3>
        <pre>
          <code>{`<div style="background-color: #007bff; color: white; padding: 20px;">
  This div has background color and padding.
</div>`}</code>
        </pre>

        {/* Div with class */}
        <h3>Div with CSS class</h3>
        <pre>
          <code>{`<div class="container">
  <h2>Container Header</h2>
  <p>Content inside the container div.</p>
</div>`}</code>
        </pre>
      </section>

      {/* 5. Nesting divs */}
      <section id="nesting">
        <h2>5. Nesting divs</h2>
        <p>Div elements can be nested to create complex layouts:</p>
        <pre>
          <code>{`<div class="outer">
  <div class="inner">
    <p>Nested content</p>
  </div>
</div>`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Use <code>&lt;div&gt;</code> for structural grouping of elements.</li>
          <li>Avoid excessive use of divs; use semantic elements when possible (e.g., <code>&lt;header&gt;</code>, <code>&lt;section&gt;</code>).</li>
          <li>Combine divs with classes and IDs for layout and styling with CSS.</li>
          <li>Keep HTML readable and maintainable by organizing nested divs properly.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>The <code>&lt;div&gt;</code> element is a generic container with no semantic meaning.</li>
          <li>It is widely used with CSS for styling and with JavaScript for dynamic behavior.</li>
          <li>Can contain any block or inline elements, and divs can be nested.</li>
          <li>Use semantic HTML where appropriate to improve accessibility and SEO.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLDiv;
